import React from 'react';
import {ReactComponent as Close} from '../../../../assets/icon/close.svg';
import {CancelIconContainer} from './ModalIcon.styled';
import {IModalIconProps} from "./ModalIcon.helper";

export const CancelIcon: React.FC<IModalIconProps> = ({clickHandler}) => {
  return <CancelIconContainer onClick={clickHandler}><Close/></CancelIconContainer>;
};
